import moment from 'moment'

export const getJsonDate = (date: Date): string => {
  return date.toISOString().slice(0, 10)
}

export const getTomorrowDate = (): Date => {
  const today = getUtcNow()
  const tomorrow = new Date(today)
  tomorrow.setDate(tomorrow.getDate() + 1)
  return tomorrow
}

export const HoursPerDay = 24
export const MinutesPerHour = 60
export const SecondsPerMinutes = 60
export const SecondsPerHour = MinutesPerHour * SecondsPerMinutes
export const SecondsPerDay = HoursPerDay * SecondsPerHour
export const MillisecondsPerSecond = 1000

export const getDeltaSeconds = (from: Date, to: Date): number => {
  return Math.round((from.getTime() - to.getTime()) / MillisecondsPerSecond)
}

export const getDeltaDays = (from: Date, to: Date): number => {
  return (
    (from.getTime() - to.getTime()) / (MillisecondsPerSecond * SecondsPerDay)
  )
}

export const getUtcNow = (): Date => {
  return moment.utc().toDate()
}

export const getOnlyTime = (date: Date): string => {
  const timestamp = date.getTime()
  let hours = Math.floor(
    (timestamp %
      (MillisecondsPerSecond *
        SecondsPerMinutes *
        MinutesPerHour *
        HoursPerDay)) /
      (MillisecondsPerSecond * SecondsPerMinutes * MinutesPerHour)
  )
  let minutes = Math.floor(
    (timestamp % (MillisecondsPerSecond * SecondsPerMinutes * MinutesPerHour)) /
      (MillisecondsPerSecond * SecondsPerMinutes)
  )
  let seconds = Math.floor(
    (timestamp % (MillisecondsPerSecond * SecondsPerMinutes)) /
      MillisecondsPerSecond
  )

  return `${FormatNumberLength(hours, 2)}:${FormatNumberLength(
    minutes,
    2
  )}:${FormatNumberLength(seconds, 2)}`
}

const FormatNumberLength = (value: number, length: number): string => {
  var r = '' + value
  while (r.length < length) {
    r = '0' + r
  }
  return r
}
